<template>
  <v-container
    pa-2
  >
    <h2>
      Let's Chat
    </h2>
    <p>I'd love to bring your ideas to life. Tell me a little bit about how I can help!</p>
    <v-form
      name="contact"
      style="color: #e15cf0 !important;"
      v-model=valid
      method="post"
      netlify
      data-netlify="true"
      data-netlify-honeypot="bot-field"
    >
      <v-text-field
        v-model="name"
        label="Your Name"
        name="name"
      ></v-text-field>
      <v-text-field
        v-model="twitchName"
        label="Twitch Name"
        name="twitchName"
      ></v-text-field>
      <v-text-field
        v-model="email"
        label="Email"
        name="email"
      ></v-text-field>

      <v-select
        dark
        :items=items
        name="commission"
        label="What can I make for you?"
      ></v-select>

      <v-textarea
        v-model="message"
        label="Tell me about your ideas!"
        name="message"
      ></v-textarea>
      <v-btn
        text-right
        color="primary"
        text-white
        type="submit"
      >
        Submit
      </v-btn>
    </v-form>
  
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      valid: '',
      name: '',
      email: '',
      twitchName: '',
      items: [
        'Emotes',
        'Logo',
        'Panels',
        'Chibi',
        'Avatar',
        'Twitch Package'
      ]
    }
  }
}
</script>
